import script from "./VTextField.vue?vue&type=script&setup=true&lang=js"
export * from "./VTextField.vue?vue&type=script&setup=true&lang=js"

import "./VTextField.vue?vue&type=style&index=0&id=6ed08c2e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ed08c2e"]])

export default __exports__